@if (showPagination && totalPages() > 0) {
  <div class="flex justify-between items-center mt-4">
    <!-- Dropdown de items por página -->
    <div class="flex flex-1 items-center min-w-20">
      <div class="relative w-[50px] mr-2">
        <app-minimal-select
          [options]="pageSizeOptions"
          [initialValue]="pageSize"
          (selectionChange)="onPageSizeChange($event)">
        </app-minimal-select>
      </div>
      <span class="hidden sm:flex text-text-secondary text-sm font-medium justify-center">{{ itemType }} <span class="hidden md:flex">&nbsp;por página</span></span>
    </div>

    <!-- Navegación central -->
    <div class="flex items-center justify-center flex-1 gap-1">
      <!-- Botón anterior -->
      <button
        class="rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="goToPage(currentPage - 1)"
        [disabled]="currentPage === 1"
      >
        <i class="fi fi-rr-angle-small-left text-text-primary text-xl justify-center flex"></i>
      </button>

      <!-- Números de página -->
      <div class="flex">
        @for (page of visiblePages(); track page) {
          <button
            class="w-8 h-8 rounded flex items-center justify-center text-base font-medium"
            [class]="
              currentPage === page
                ? ' border-primary-g500 rounded-md border-[2px] text-primary'
                : 'text-secondary'
            "
            (click)="goToPage(+page)"
          >
            <span
              class="leading-none justify-center flex mt-[1px]"
              [class]="
                currentPage === page
                  ? ' text-base font-medium text-text-primary'
                  : ' text-sm font-normal text-text-secondary'
              "
            >
              {{ page }}
            </span>
          </button>
        }
      </div>

      <!-- Botón siguiente -->
      <button
        class="rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="goToPage(currentPage + 1)"
        [disabled]="currentPage >= totalPages()"
      >
        <i class="fi fi-rr-angle-small-right text-text-primary text-xl leading-none justify-center flex"></i>
      </button>
    </div>

    <!-- Contador de resultados -->
    <div class="text-sm text-text-secondary font-medium flex justify-end flex-1 pr-2 min-w-20">
      {{ getResultsText() }}
    </div>
  </div>
}